import { Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { TranslationKey } from "../../../../../localization/translations"

import { heroFontFamily } from "./heroFont"

const useStyles = makeStyles()((theme) => ({
    value: {
        fontFamily: heroFontFamily,
        fontSize: "2.25rem",
        fontWeight: 600,
        lineHeight: 1.1,
        color: theme.palette.tailwind.slate[900],
    },
    label: {
        fontStyle: "italic",
        color: theme.palette.tailwind.slate[500],
    },
}))

type HeroStatProps = Readonly<{
    value: string
    labelId: TranslationKey
}>

export function HeroStat({ value, labelId }: HeroStatProps) {
    const { classes } = useStyles()

    return (
        <Stack>
            <Typography component="span" className={classes.value}>
                {value}
            </Typography>
            <LocalizedStrict id={labelId}>
                <Typography variant="caption" className={classes.label}>
                    label
                </Typography>
            </LocalizedStrict>
        </Stack>
    )
}
